import { NavigateFunction } from 'react-router-dom';

/** Handle fork / reject responses from bidding mutation APIs. Returns true if navigated away. */
export function handleBiddingMutationPayload(
  data: any,
  navigate: NavigateFunction,
  currentSheetId?: string
): boolean {
  if (!data || typeof data !== 'object') return false;

  if (data.code === 'BIDDING_REVISION_REJECTED' && data.redirectToSheetId) {
    navigate(`/bidding/${data.redirectToSheetId}`);
    return true;
  }

  if (
    (data.code === 'BIDDING_FORKED' || data.forked) &&
    data.redirectToSheetId &&
    data.redirectToSheetId !== currentSheetId
  ) {
    navigate(`/bidding/${data.redirectToSheetId}`);
    return true;
  }

  return false;
}

export async function readBiddingMutationResponse(
  response: Response,
  navigate: NavigateFunction,
  currentSheetId?: string
): Promise<any> {
  const data = await response.json().catch(() => ({}));
  handleBiddingMutationPayload(data, navigate, currentSheetId);
  if (!response.ok && data.code !== 'BIDDING_FORKED') {
    const err = new Error(data.error || `HTTP ${response.status}`) as Error & {
      code?: string;
      data?: any;
    };
    err.code = data.code;
    err.data = data;
    throw err;
  }
  return data;
}
